import * as z from 'zod';

export const LookupSchema = z.object({
  address: z.string().trim().min(3, 'parcelWatch.lookup.enterAddress').max(200),
});
